import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { porneste } from "./observare";
import "./theme.css";
import "./components/imprimanta.css";
import "./app.css";
import "./viewer/viewer.css";
// the structure theme + the ported legacy page styles come AFTER the platform
// theme on purpose: they refine its tokens, they never redefine them — and
// importing them here (not in App.tsx) keeps that order in the built CSS
import "./structure/tema.css";
import "./structure/legacy.css";

// Înainte de randare: o cădere la primul ecran e tot o cădere.
porneste();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
